<template>

  <v-card>

      

      <v-card-text>

        <v-container>

          <v-row v-if="loading" justify="center" align="center">
            <v-progress-circular
              indeterminate
              color="rgba(183,175,200,1)"
            ></v-progress-circular>
          </v-row>

          <v-row v-if="!loading">
            <v-container>
              {{answer}}
            </v-container>
          </v-row>

        </v-container>

      </v-card-text>

    </v-card>

</template>

<script>

export default {
  name: 'Output',

  props: {
    answer: String,
    loading: Boolean
  }
  
}

</script>

<style scoped>
#header {
  overflow: hidden;
  height: 2vh;
}
</style>
